import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useFormContext } from "./formElements";
import { FansInspectionChecklist } from "./FansInspectionChecklist";
import { CurrentMeasureTable } from "./CurrentMeasureTable";
import { FileUploader } from "./FileUploader";

// stabilne klucze Reacta dla elementów listy (usunięcie ze środka nie przesuwa stanu komponentów)
const itemKeys = new WeakMap();
let nextItemKey = 0;
const keyOf = (item) => {
  if (!itemKeys.has(item)) itemKeys.set(item, nextItemKey++);
  return itemKeys.get(item);
};

// pojedyncza rozdzielnica: lista kontrolna, pomiary prądu silnika, zdjęcia
function FansMeasurementsItem({ value }) {
  return (
    <>
      {value.fans_inspection_checklist ? (
        <FansInspectionChecklist value={value.fans_inspection_checklist} />
      ) : null}
      {value.table_current_measure ? (
        <CurrentMeasureTable value={value.table_current_measure} />
      ) : null}
      {value.file_uploader ? <FileUploader value={value.file_uploader} /> : null}
    </>
  );
}

export default function FansMeasurements(props) {
  const element = props.value;
  const { onChange } = useFormContext();

  // starszy model bez listy - elementy trzymane bezpośrednio w obiekcie
  if (!Array.isArray(element.value)) {
    return (
      <div className={element.class}>
        <FansMeasurementsItem value={element} />
      </div>
    );
  }

  const addItem = () => {
    // głęboka kopia szablonu - nowy obiekt, bez współdzielonych referencji
    const newItem = JSON.parse(JSON.stringify(element.item ?? {}));
    element.value = [...element.value, newItem];
    onChange({ ...element });
  };

  const removeItem = (index) => {
    if (!window.confirm("Czy na pewno chcesz usunąć tę rozdzielnicę?")) return;
    element.value = element.value.filter((_item, i) => i !== index);
    onChange({ ...element });
  };

  return (
    <div className={element.class}>
      {element.value.map((item, index) => (
        <div key={keyOf(item)} className={index > 0 ? "border-top pt-3 mt-4" : ""}>
          <div className="text-end">
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => removeItem(index)}
              title="Usuń rozdzielnicę"
            >
              <FontAwesomeIcon icon={faTrash} /> Usuń rozdzielnicę
            </Button>
          </div>
          <FansMeasurementsItem value={item} />
        </div>
      ))}
      {element.item ? (
        <Button variant="outline-primary" className="mt-3" onClick={addItem}>
          <FontAwesomeIcon icon={faPlus} /> Dodaj rozdzielnicę
        </Button>
      ) : null}
    </div>
  );
}
